(() => {
  if (window.Shopify?.designMode) return;
  function wire(root) {
    if (root.dataset.analyticsWired) return;
    const endpoint = root.dataset.analyticsUrl || '';
    if (!/^https:\/\/script\.google\.com\/macros\/s\/[\w-]+\/exec$/.test(endpoint)) return;
    root.dataset.analyticsWired = 'true';
    const campaign = root.dataset.campaign;
    if (!/^[a-zA-Z0-9_-]{1,64}$/.test(campaign)) return;
    const key = 'th-quiz-metrics-' + campaign;
    const pendingKey = key + '-pending';
    const dialog = root.querySelector('dialog');
    let memory = {};
    try { memory = JSON.parse(localStorage.getItem(key) || '{}'); } catch (_) {}
    const permitted = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    function send(event, extra = {}) {
      if (!permitted() || memory[event]) return;
      memory[event] = true;
      try { localStorage.setItem(key, JSON.stringify(memory)); } catch (_) {}
      const body = new URLSearchParams({payload:JSON.stringify({version:1,campaign,event,...extra})});
      fetch(endpoint, {method:'POST',mode:'no-cors',credentials:'omit',referrerPolicy:'no-referrer',body,keepalive:true})
        .catch(() => {delete memory[event];try {localStorage.setItem(key,JSON.stringify(memory));} catch (_) {}});
    }
    function inspect() {
      if (dialog.open) send('view');
      let pending = 0;
      try {pending = Number(sessionStorage.getItem(pendingKey));} catch (_) {}
      if (pending && Date.now()-pending<1800000 && root.querySelector('[data-wq-posted]') && permitted()) {
        send('signup');
        try {sessionStorage.removeItem(pendingKey);} catch (_) {}
      }
    }
    root.querySelectorAll('[data-wq-choice]').forEach((button,index) => {
      button.addEventListener('click',() => {
        const copy=button.cloneNode(true);
        copy.querySelectorAll('[aria-hidden]').forEach(el=>el.remove());
        const answer=copy.textContent.replace(/→/g,'').replace(/\s+/g,' ').trim().slice(0,120);
        send('answer',{option:index+1,answer});
      },{passive:true});
    });
    root.querySelector('form').addEventListener('submit',event => {
      if (!event.target.checkValidity() || !permitted()) return;
      try {sessionStorage.setItem(pendingKey,String(Date.now()));} catch (_) {}
    },{passive:true});
    const observer=new MutationObserver(inspect);
    observer.observe(dialog,{attributes:true,attributeFilter:['open']});
    document.addEventListener('visitorConsentCollected',inspect);
    if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)inspect();});
    }
    inspect();
  }
  document.querySelectorAll('th-welcome-quiz').forEach(wire);
})();
